import CallbackHistoryViewContainer from './CallbackHistoryView.container';

export default CallbackHistoryViewContainer;
